function openSizeRecommendationDialog(client, style, locale) {
    function getVariants() {
        const el = document.getElementById('sizera-variants-data');
        if (!el) {
            return {};
        }
        return JSON.parse(el.dataset.variants).reduce((acc, v) => {
            acc[v.key] = {id: v.id, a: v.a, p: v.p};
            return acc;
        }, {});
    }

    const variants = getVariants()

    window.sizeraApp?.push(['open', {
        client: client, reference: style, locale: locale, products: variants, onAddToCart: async event => {
            const key = `${event.reference}:${event.size}`;
            const variant = variants[key];
            if (variant) {
                await fetch(`${Shopify.routes.root}cart/add.js`, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({
                        items: [{quantity: event.quantity, id: variant.id}]
                    })
                });
                document.dispatchEvent(new CustomEvent("cart:refresh"));
                document.dispatchEvent(new CustomEvent("variant:add"));
            }
        }
    }]);
}

class SizeRecommendation extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.fetchRecommendation();
    }

    async fetchRecommendation() {
        const client = this.getAttribute('client');
        const style = this.getAttribute('style');
        const locale = this.getAttribute('locale');
        window.sizeraApp?.push(["load", {
            client: client,
            style: style,
            locale: locale
        }])?.then((result) => {
            this.innerHTML = `<span class="text-subdued">${result.recommendation}</span>`;
            const urlParams = new URLSearchParams(window.location.search);
            const variantFromUrl = urlParams.get('variant');
            const option = Array.from(document.querySelectorAll('.variant-picker__option-values label > span')).filter(e => e.textContent === result.size)[0];
            if (option && !variantFromUrl) {
                option.click();
            }
        });
    }
}

customElements.define('size-recommendation', SizeRecommendation);

class SizeRecommendationTrigger extends HTMLElement {
    constructor() {
        super();
        const client = this.getAttribute('client');
        const style = this.getAttribute('style');
        const locale = this.getAttribute('locale');
        const button = this.querySelector('button');
        if (button) {
            button.addEventListener('click', () => {
                openSizeRecommendationDialog(client, style, locale);
            });
        }
    }
}

customElements.define('size-recommendation-trigger', SizeRecommendationTrigger);